/* eslint-disable react/no-unescaped-entities */
"use client";

import React, { useState, useRef, useEffect } from "react";

import Heading from "@/components/heading/heading";
import Button from "@/components/button/Button";

import Arrow from "@/public/svg/arrow-right.svg";
import Buttonwhatsapp from "@/public/svg/common/social-icons/whatsapp.svg";
import RightIcon from "@/public/svg/line-arrow-right.svg";

import Image from "next/image";

import "@/sections/common/tariff/tariff.scss";

const Tariff = () => {
    const [showSecondContainer, setShowSecondContainer] = useState(false);
    const secondContainerRef = useRef<HTMLDivElement | null>(null);

    const handleViewMore = () => {
        setShowSecondContainer(true);
    };

    const handleViewLess = () => {
        setShowSecondContainer(false);

        const familyPackagesElement = document.getElementById("tariffsection");
        if (familyPackagesElement) {
            familyPackagesElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        if (secondContainerRef.current) {
            if (showSecondContainer) {
                // Set max-height to the actual height of the content for smooth transition
                const contentHeight = secondContainerRef.current.scrollHeight;
                secondContainerRef.current.style.maxHeight = `${contentHeight}px`;
            } else {
                secondContainerRef.current.style.maxHeight = "0";
            }
        }
    }, [showSecondContainer]);

    return (
        <section className="tariff-section pt-6" id="tariffsection">
            <div className="container px-4 mx-auto">
                <div className="tariff-wrapper flex flex-col gap-6 p-3 md:p-6">
                    <div className="tariff-head pb-3">
                        <Heading as="h2">
                        Thailand: The Best Destination Asia Pacific Awaits
                        </Heading>
                    </div>
                    <div className="tariff-body-footer flex flex-col gap-4">
                        <div className="tariff-body flex flex-col gap-4 px-3 md:px-6">
                            <div className="flex flex-col gap-4">
                                <p className="lead"><strong>“One of the dreams on my wish list is to spend more time in Thailand.”</strong></p>
                                <p className="lead">
                                    <strong>- Kevin Kwan
</strong>
                                    {!showSecondContainer && (
                                        <span
                                            className="font-medium view-more ml-4 cursor-pointer text-blue-600 hover:text-blue-800"
                                            onClick={handleViewMore}
                                        >
                                            View More
                                        </span>
                                    )}
                                </p>
                            </div>
                            <div
                                id="second-container"
                                ref={secondContainerRef}
                                className={`transition-all duration-500 overflow-hidden ${
                                    showSecondContainer
                                        ? "max-h-full opacity-100"
                                        : "max-h-0 opacity-0"
                                }`}
                            >
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Introduction
                                    </Heading>
                                    <p className="lead">
                                    Thailand is the heart of Southeast Asia. A land of magic and wonder, it is the perfect vacation destination, catering to solo adventurers, families with kids, and even honeymoon couples. Nestled on the Indo-Chinese Peninsula, this country is a treasure trove of rich history, culture, and traditions, offering many unique experiences that more than one visit is needed to grasp fully. From its vibrant art scene to its lively entertainment, the Kingdom of Thailand is always ready to captivate you with its beauty.
                                    </p>

                                    <p className="lead">
                                    If Thailand is on your to-go bucket list, you have landed on the right page. Dimaak Tours is your best travel partner for planning your unforgettable trip to Thailand. We provide the best Thailand tour package at a very affordable price. We have designed travel itineraries to suit people of all ages. We have customizable options for sightseeing and duration, so give us your word, and we will craft an itinerary for you. Also, the best part of our Thailand holiday package is that we offer it for Pan India customers.
                                    </p>
                                    <p className="lead">
                                    Holidays are meant for joy, living your vacation to the fullest, and creating lasting memories. At Dimaak Tours, we understand this, which is why we have expert travel planners dedicated to making your dream vacation in Thailand a reality. With their in-depth knowledge of Thailand's hidden gems and local insights, they can curate a personalized itinerary that caters to your every whim. From budget-friendly to luxurious accommodations, from must-see Thailand destinations to must-try local dishes, they will provide you with a comprehensive guide to everything you need, ensuring your trip is smooth and unforgettable.

                                    </p>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Best Time to Visit Thailand
                                    </Heading>
                                    
                                    <p className="lead">
                                    Though Thailand welcomes its tourists with open arms all season, choosing the best time to visit Thailand for vacation doubles the fun. It has tropical weather all year round. However, the ideal time to visit from India is from November to February; during this time of the year, the temperature in Thailand experiences its cool season. The temperature and humidity levels will be lower compared to the rest of the year. This makes activities more enjoyable, whether you're exploring cities, trekking in the mountains, or relaxing on the beaches.
                                    </p>
                                    <p className="lead">
                                    Many festivals and events take place during the cool season, including the Loy Krathong festival in November and the Thai New Year (Songkran) in April. These celebrations offer unique cultural experiences and vibrant atmospheres that attract visitors from around the world.
                                    </p>
                                    <p className="lead">
                                    While November to February is considered the best time to visit Thailand, it's also the peak tourist season. Despite the higher number of tourists, the cooler and drier weather makes it more comfortable to explore popular destinations without feeling overwhelmed by heat and humidity.
                                    </p>
                                    <p className="lead">
                                    Overall, the combination of pleasant weather, fewer rain showers, and cultural festivities make November to February an optimal time to experience Thailand's diverse attractions.</p>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    How to Reach Thailand from India
                                    </Heading>

                                    <p className="lead">
                                    Here are the lists of some airports in Thailand -
                                    </p>

                                    <ul>
                                        <li>
                                            Suvarnabhumi International Airport, Bangkok <strong> (BKK) </strong>
                                        </li>
                                        <li>
                                        Don Mueang International Airport, Bangkok <strong> (DMK) </strong>
                                        </li>
                                        <li>
                                        Phuket International Airport <strong> (HKT) </strong>
                                        </li>
                                        <li>
                                        Krabi International Airport <strong> (KBV) </strong>
                                        </li>
                                        <li>
                                        Samui International Airport, Koh Samui <strong> (USM) </strong>
                                        </li>
                                        <li>
                                        Surat Thani International Airport <strong> (URT) </strong>
                                        </li>
                                        <li>
                                        Chiang Mai International Airport <strong> (CNX) </strong>
                                        </li>
                                        
                                    </ul>
                                    <p className="lead"><strong>Airways: </strong> Airways such as IndiGo, Thai Airways, Thai Lion Air, AirAsia, Spicejet, and Air India offer their flights to Thailand. Usually, the flight cost from India to Thailand starts at 7000 INR and 20000 INR for one way.</p>
                                    <p className="lead"><strong>Direct Flight: </strong> Direct flights are available from Delhi, Mumbai, Chennai, Kolkata, and Bengaluru. Flights for Thailand usually depart late at night and land early, between 4 a.m. and 8 a.m. in the morning. The travel time is 3-4 hours.</p>
                                    
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h4">
                                    Tips to Find Cheaper Flights
                                    </Heading>

                                    <ul>
                                        <li>
                                        If you want a cheap Thailand tour package with airfare, Thailand has two major airports: Suvarnabhumi International Airport and Don Mueang International Airport.
                                        </li>

                                        <li>
                                        Landing at Don Mueang International Airport (DMK) will be cost-efficient, as it provides a hanger for Low-cost Airlines, and thus, flights landing here will be cheap.
                                        </li>

                                        <li>
                                        On the other hand, landing at Suvarnabhumi International Airport (BKK) will cost a little more as Premium Airlines lands here, which also costs more. 
                                        </li>
                                        <li>
                                        So, choosing Don Mueang International Airport (DMK) to land at and low-cost airlines can help you save a bit.
                                        </li>
                                        <li>
                                        Cheaper flights are usually on the weekdays and off-season.
                                        </li>
                                    </ul>
                                    <p className="lead">
                                    [Additional Tip - Landing at Krabi or Koh Samui is expensive; choosing Bangkok to land will be the best option].

                                    </p>
                                    
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Visa and Currency
                                    </Heading>
                                    <p className="lead">
                                    The visa requirements for Indians to travel to Thailand are given below-

                                    </p>
                                    <ul>
                                        <li>
                                        <strong> On-arrival - </strong> Visa on arrival is given upon reaching Thailand. After reaching, you need to stand in Line A and pay 2000 Baht (INR. approx. 5000) to get their Visa. Once you get your visa, stand in another queue for Visa Stamping.

                                        </li>
                                        <li>
                                        <strong> E-visa - </strong> E-visas are quite easy to get. You just need to fill out the form and make payment, and the visa application will be sent to your registered email ID. If you have gotten your Visa from India, after reaching, you need to stand in Line B to get it stamped.

</li>
                                        
                                    </ul>
                                    <p className="lead">
                                    (*in case you need to get your On-arrival Visa process done quicker, additional 200 Baht should be deposited)
                                    </p>
                                    <p className="lead">
                                    [<strong>Additional Information:</strong> 2 hours is required to finish the Visa process and get stamped]

                                    </p>
                                    <p className="lead">
                                    For more details, <a
                                                target="_blank"
                                                href="https://dimaak.com/blog/on-arrival-visa-for-thailand/"
                                            >
                                                <i>
                                                    <u>
                                                        {" "}
                                                        click here.
                                                    </u>
                                                </i>
                                            </a> 
                                    </p>
                                    <p className="lead">The Thai Baht is Thailand's currency, abbreviated as THB.</p>
                                    <p className="lead">The baht is the official currency of the Kingdom of Thailand, issued by the Bank of Thailand. Its symbol is "฿."</p>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h4">
                                    Places to Exchange Currency in Thailand
                                    </Heading>
                                    <ul>
                                        <li>
                                            <strong>
                                            Banks:
                                            </strong>{" "}
                                            They provide the service for currency exchange and are safe and trustworthy.
                                        </li>
                                        <li>
                                            <strong>
                                            Currency Exchange Counters:
                                            </strong>{" "}
                                            You can easily find them in airports, major train stations, shopping malls, and tourist places, but the charges are too high.
                                        </li>
                                        <li>
                                            <strong>
                                            ATMs:
                                            </strong>{" "}
                                            You can use your debit or credit card from any international bank to withdraw money from ATMs.
                                        </li>
                                        <li>
                                            <strong>
                                            Licensed Money Changers:
                                            </strong>{" "}
                                            They are usually private shops that exchange money. You will easily get them in tourist spots.
                                        </li>
                                    </ul>
                                    <Heading as="h4">
                                    Tips to Find Cheaper Flights:
                                    </Heading>
                                    <ul>
                                        <li>
                                        Roam and compare the rates before you make an exchange.
                                        </li>
                                        <li>
                                            Ask about the exchange rates before exchanging your currency.
                                        </li>
                                        </ul>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Famous Cities to Visit in Thailand
                                    </Heading>
                                    <p className="lead">
                                    Whether you need a solo escape, a family vacation trip or a <a
                                                target="_blank"
                                                href="https://dimaak.com/thailand/honeymoon-packages"
                                            >
                                                <i>
                                                    <u>
                                                        {" "}
                                                        honeymoon couple looking for a romantic getaway,
                                                    </u>
                                                </i>
                                            </a> Thailand is paradise.
                                    </p>
                                    <p className="lead">
                                    <strong>Phuket, Krabi, Koh Samui, Bangkok, Pattaya, Chiang Mai, and Chiang Rai</strong> are the popular cities in Thailand for tourists where you should spend most of your vacation.
                                    </p>
                                    <p className="lead">
                                    Let me help you understand Thailand better and plan your trip better.
                                    </p>
                                    <p className="lead">
                                    <strong>A Familial tour </strong> is what we all want a year. <a
                                                target="_blank"
                                                href="https://dimaak.com/thailand/family-packages"
                                            >
                                                <i>
                                                    <u>
                                                        {" "}
                                                        Planning a family trip with kids to Thailand 
                                                    </u>
                                                </i>
                                            </a>  won’t disappoint you because it can satisfy everyone’s taste. For the elderly who are looking for a cultural aspect or kids who want a fantasy, dream-like world, Thailand has everything from temples and shrines for elders to entertainment parks for kids. Also, it offers the best-kept wildlife and biodiversity, where families get the chance to interact, feed and play with the animals. This initiative helps your family stay connected and bond more while spending time with wildlife.
                                    </p>
                                    <p className="lead">
                                    <strong>Solo Trips </strong>  can be fun and adventurous, too. Solo travelers can have a budget-friendly and fun-filled experience in Thailand. From delicious, affordable food to welcoming locals, Thailand makes it easy for its solo travelers. Therefore, Thailand welcomes and provides exploration opportunities for solo travelers.
                                    </p>


                                    
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Thailand’s Art, Culture & Architecture
                                    </Heading>
                                    <p className="lead">
                                    To explore Thailand’s art, culture and history, you <a target="_blank"
                                                href="https://dimaak.com/blog/chiang-mai-temples/"
                                            >
                                                <i>
                                                    <u>
                                                        {" "}
                                                        must visit temples, 
                                                    </u>
                                                </i>
                                            </a>  shrines and monuments to catch a glimpse of its beauty. The temples and shrines reflect the country's spiritual side. Ayutthaya highlights the ancient temples, and Chiang Mai boasts its serene sanctuaries.
                                    </p>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Architectural Marvels:
                                    </Heading>
                                    <p className="lead">
                                    Thailand’s architecture serves as a testament to its heritage and artistry. The central part of Thailand exhibits the Grand Palace and temples made with mosaics and intricate details.
                                    </p>
                                    <ul>
                                        <li>
                                        Bangkok City Tour
                                        </li>
                                        <li>
                                        Chiang Mai City Tour
                                        </li>
                                        <li>
                                        Pattaya City Tour
                                        </li>
                                        <li>
                                        Sanctuary Of Truth, Pattaya
                                        </li>
                                        <li>
                                        Ancient City, Siam
                                        </li>
                                        <li>
                                        Grand Palace
                                        </li>
                                        <li>
                                        Ayutthaya Historical Park
                                        </li>
                                    </ul>
                                    <p className="lead">
                                    The best way to learn about Thailand's art and culture is to take Thailand city tours. These city tours take you to various landmarks and give insights on the country's history, culture, art, and traditions. Monuments such as the Grand Palace, Sanctuary of Truth and Ancient City highlight the architectural marvel of Thailand.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Temples and Shrines
                                    </Heading>
                                    <ul>
                                        <li>
                                        Wat Traimit Withayaram Worawihan (Golden Buddha)
                                        </li>
                                        <li>
                                        Wat Benchamabophit Dusitwanaram (Marble Buddha)
                                        </li>
                                        <li>
                                        Wat Phra Kaew (Emerald Buddha)

                                        </li>
                                        <li>
                                        Wat Arun (Temple of Dawn)
                                        </li>
                                        <li>
                                        Erawan Shrine, Bangkok
                                        </li>
                                    </ul>
                                    <p className="lead">
                                    Thailand is the second largest country following Buddhism. 93% of the population practices Buddhism; thus, we can find most Buddhist temples. Buddhist values like kindness, generosity and calmness are reflected in Thai people.
                                    </p>
                                    
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Entertainment Parks in Thailand for All
                                    </Heading>
                                    <p className="lead">
                                    Thailand offers people who want to experience the height of adrenaline rush the chance. It is a land exclusively for thrill seekers. You will get all the classic rides and also can experience a winter wonderland through its snow world. Below is a list of some entertainment parks. Visit them to experience the fun of adventure.
                                    </p>

                                    <ul>
                                        <li>
                                        Siam Amazing Park Bangkok
                                        </li>
                                        <li>
                                        Dream World Bangkok,
                                        </li>
                                        <li>
                                        Frost Magical Ice of Siam Pattaya
                                        </li>
                                        <li>
                                        Phuket FantaSea
                                        </li>
                                        <li>
                                        Ramayana Water Park
                                        </li>
                                        <li>
                                        Vana Nava Water Jungle
                                        </li>
                                        <li>
                                           Snow Town, Bangkok
                                        </li>
                                        
                                    </ul>

                                    
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Wildlife and Biodiversity in Thailand
                                    </Heading>
                                    <p className="lead">
                                    Thailand is home to a rich biodiversity. Experience and enjoy the best-kept terrestrial ocean’s incredible biodiversity and marine creatures in Thailand. Feeding exercises with wildlife help you bond more with your own people. Below are given wildlife and marine parks, which give you the chance to interact with and feed wildlife.
                                    </p>
                                    <ul>
                                        <li>
                                        Bangkok Safari World and Marine Park
                                        </li>
                                        <li>
                                        Elephant Sanctuary, Chiang Mai
                                        </li>
                                        <li>
                                        Tiger Topia, Pattaya
                                        </li>
                                        <li>
                                        Sealife Ocean World, Bangkok
                                        </li>
                                    </ul>
                                    
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Theatre and Museums
                                    </Heading>
                                    <p className="lead">
                                    If you are curious about deepening your understanding of Thailand's artistic tradition and learning about Thai culture and tradition, you can visit the theaters to watch Thai performances, such as Thai dance shows, puppetry shows and Muay Thai boxing matches.
                                    </p>
                                    <p className="lead">
                                    Get ready to do crazy things in Thailand. The museum highlights  9 themed zones with 90 wax figures of popular personalities from around the world. Also, the optical illusionary experience will blow your mind. Thailand offers the best transvestite cabaret show in the world.
                                    </p>
                                    <ul>
                                        <li>
                                        Madame Tussauds Museum, Bangkok
                                        </li>
                                        <li>
                                        Art in Paradise Museum, Bangkok
                                        </li>

                                        <li>
                                        The Alcazar Show, Pattaya

                                        </li>

                                        <li>
                                        Fantasea and Carnival Show, Phuket
                                        </li>
                                        <li>
                                        Sala Chalermkrung Royal Theatre
                                        </li>
                                        <li>
                                        Joe Louis Thai Puppet Theater
                                        </li>
                                        <li>
                                        Aksra Theatre
                                        </li>
                                        <li>Siam Niramit (Phuket)</li>
                                    </ul>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Beach Hopping and Water Adventures:
                                    </Heading>
                                    <p className="lead">
                                    Thailand has beautiful islands with tall limestones, crystal-clear turquoise waters, and various coral and marine life. If you are a lazy lad and want to relax on the beach and enjoy the beauty of nature, then Thailand is heaven for you.

                                    </p>
                                    <p className="lead">
                                    You can indulge yourself in water sports like snorkeling, scuba diving, parasailing, jet skiing, banana rides, and sea walking.
                                    </p>
                                    <ul>
                                        <li>
                                        James Bond Island + Sea Canoeing
                                        </li>
                                        <li>
                                        Phi Phi Island & Maya Bay Beach with Snorkeling
                                        </li>
                                        <li>
                                        Coral Island Water Sports
                                        </li>
                                    </ul>
                                    
                                    
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Romantic Escape for Honeymoon Couples
                                    </Heading>
                                    <p className="lead">
                                    Rooftop Bars, Dinner Cruises and Candlelight Dinners are usually the things to do in Thailand for honeymoon couples for an unforgettable experience.
                                    </p>
                                    <p className="lead">
                                    Rooftop bars offer the best dining options in the evening when the sun sets, the sky changes color, and the moon gets ready to light up. To make their Honeymoon extra special, couples can go to dinner cruises or candlelight dinners. Given below are some of the best places to visit-
                                    </p>
                                    <Heading as="h3">
                                    Rooftop Bars
                                    </Heading>
                                    <p className="lead">
                                    Evening- The best time to go to the rooftop bars. This allows honeymoon couples to enjoy breathtaking views of the city. Some of the popular rooftop restaurants offer a stunning view of Wat Arun, which sits between Wat Arun and Wat Pho. DJ music makes your heart happy, and food fills your stomach and heart.
                                    </p>
                                    <ul>
                                        <li>
                                        Sirocco, Bangkok
                                        </li>
                                        <li>
                                        The Roof (Rooftop Bar), Bangkok
                                        </li>

                                        <li>
                                        Mojjo Rooftop Lounge Bar
                                        </li>
                                        <li>
                                        Three Sixty Skybar, Bangkok

                                        </li>
                                    </ul>

                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Dinner Cruises
                                    </Heading>
                                    <p className="lead">
                                    Grabbing your dinner in the middle of the river and enjoying the view of the beautiful city will be a lifetime experience. The cruise operates between 7:30 and 9:30 p.m. and takes you through the Chao Phraya River, where you can enjoy the city view, good food, and live music. These are the cruises that are mostly chosen.
                                    </p>
                                    <ul>
                                        <li>
                                        Chao Phraya Princess Cruise
                                        </li>
                                        <li>
                                        Manohra Cruises
                                        </li>

                                        <li>
                                        The Wonderful Pearl Cruise

                                        </li>
                                    </ul>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Candlelight Dinners
                                    </Heading>
                                    <p className="lead">
                                    Many restaurants and hotels offer romantic candlelight dinners amidst flickering candles and gentle waves, and sometimes in intimate garden settings with stunning ocean views. You can choose your own setting and make it more special.
                                    </p>
                                    <ul>
                                        <li>
                                        The Grotto, Rayavadee Resort, Krabi
                                        </li>
                                        <li>
                                        SALA Samui Chaweng Beach Resort, Koh Samui

                                        </li>

                                        <li>
                                        Four Seasons Resort, Chiang Mai

                                        </li>
                                    </ul>
                                    
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">
                                    Instagram Sightseeing
                                    </Heading>
                                    
                                    <ul>
                                        <li>
                                        Rock Beach Swing
                                        </li>
                                        <li>
                                        Khao Ngon Nak Viewpoint
                                            
                                        </li>

                                        <li>
                                        Damnoen Saduak Floating Market:
                                        </li>
                                        <li>Sa Morakot (Emerald Pool), Krabi</li>
                                    </ul>
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">Unique Things to do in Thailand</Heading>
                                    <p className="lead">
                                    The Land of Smiles always amazes you with its services. On your vacation, you will be astonished, as there are more than <a target="_blank"
                                                href="https://dimaak.com/blog/things-to-do-in-thailand/"
                                            >
                                                <i>
                                                    <u>
                                                        {" "}
                                                        40 unique things to do in Thailand 
                                                    </u>
                                                </i>
                                            </a> that will keep you occupied. You will return to your homeland not just with souvenirs but also with skills. Below are just a few things to do in Thailand:
                                    </p>
                                    <ul>
                                        <li><strong>Traditional Thai Massage: </strong> Thai massage, which originates from ancient Indian Ayurvedic and traditional Chinese medicine, blends acupressure, stretching, and yoga-like postures to alleviate tension, enhance flexibility, and induce relaxation. Sessions, typically lasting from 60 to 90 minutes, are tailored to individual needs and aim to stimulate energy flow, relieve muscular discomfort, and promote mental and emotional well-being. </li>
                                        <li><strong>Engage in a Conversation with a Monk:</strong> Many temples in Thailand offer this opportunity to engage in a conversation with Buddhist monks to learn about their way of life, spirituality, and philosophy.</li>
                                        <li><strong>Khantoke Dinner:</strong> In Khantoke dinner, guests usually sit on the floor around "Khantokes" (low tables) adorned with beautifully embroidered tablecloths and have dinner. This dinner offers a variety of northern Thai meals. The most special part about this dinner is that the guests are entertained by traditional Thai performances such as classical dances, sword dances, and traditional music played on instruments like the khim (dulcimer) and saw (fiddle).</li>
                                        <li><strong>Cooking classes:</strong> If you want to learn the art of Thai cooking, taking a Thai cooking class is the right choice. You will learn about the different ingredients used in cooking, the different techniques such as stir-frying and curry paste preparation, and how to balance flavors (sweet, sour, salty, spicy).</li>
                                    </ul>
                                    
                                </div>

                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">The Must-try Thai Delicacies for Indians</Heading>
                                    <p className="lead">
                                    Thai cuisine is flavourful and perfectly balances sweet, salty, sour, spicy, and bitter. The common combinations are of ingredients like chilies, fish sauce, palm sugar, lime juice, and fresh herbs. The most common ingredients used in Thai dishes are lemongrass, galangal (a kind of ginger), kaffir lime leaves, chilies, garlic, shallots, and fresh herbs like cilantro and Thai basil.
                                    </p>
                                    </div>
                                    <div className="flex flex-col gap-4">
                                    <Heading as="h3">Vegetarian Options in Thailand</Heading>
                                    
                                    <p className="lead"><strong>“Chan kin jay"</strong> (I am vegetarian),</p>

                                    <p className="lead"><strong>"Jay"</strong> (vegan), </p>

                                    <p className="lead"><strong>"Wegan"</strong> (vegan),</p>

                                    <p className="lead"><strong>"mai sai nam pla"</strong> means (please don't use fish sauce)
</p>
                                <p className="lead">
                                These are phrases you must learn before going to any restaurant. Vegetarian food in Thailand is readily available in tourist areas. Exploring the culinary delights of Thailand is a delicious adventure for vegetarians as well as bursting with flavor. Vegetables, tofu, coconut milk and cream, salads. Apart from veg Thai curry, there are numerous options for vegetarians to try, like-
                                </p>
                                <ul>
                                    <li>
                                    Khao Niaow Ma Muang (Sticky Mango Rice)
                                    </li>
                                    <li>
                                    Tom Kha (Coconut Soup)
                                    </li>
                                    <li>
                                    Som Tam
                                    </li>
                                    <li>
                                    Khao Pad Sapparot (Pineapple Fried Rice)
                                    </li>
                                    <li>
                                    Pak Pak (Stir-Fried Vegetables)
                                    </li>
                                    <li>
                                    Veg Pad Thai Noodles
                                    </li>
                                    <li>
                                    Thai Green Curry
                                    </li>
                                    <li>
                                    Thai Yellow Curry
                                    </li>
                                </ul>
                                    </div>
                                    <div className="flex flex-col gap-4">
                                    <Heading as="h3">Non-vegetarian options in Thailand</Heading>
                                    <p className="lead">
                                    If you are a non-vegetarian, then be ready for a feast in Thailand. Seafood lovers are going to enjoy the fiery curry bursting with mussels and vegetables. Meat lovers will find curries with chicken, pork, or beef, all infused with the complex flavors of Thai spices.
                                    </p>
                                    <ul>
                                        <li>
                                        Tom Yum Goong (Spicy Shrimp Soup)
                                        </li>
                                        <li>
                                        Gaeng Keow Wan Gai (Green Curry with Chicken)
                                        </li>
                                        <li>
                                        Pad Krapow
                                        </li>
                                        <li>
                                        Khao Pad Sapparot (Pineapple Fried Rice with Chicken/Seafood)
                                        </li>
                                        <li>
                                        Yam Nua (Spicy Beef Salad)
                                        </li>
                                        <li>
                                        Moo Satay
                                        </li>
                                        <li>
                                        Gaeng Daeng Nuea (Red Curry with Beef)
                                        </li>
                                       
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">Indian Restaurants in Thailand-</Heading>
                                    <p className="lead">
                                    Craving for your cuisine from your homeland is a common thing. If you get bored experimenting with Thai cuisine and crave some homeland taste, you can visit some <a target="_blank"
                                                href="https://dimaak.com/blog/indian-restaurants-in-phuket/"
                                            >
                                                <i>
                                                    <u>
                                                        {" "}
                                                        Indian restaurants in Thailand. 
                                                    </u>
                                                </i>
                                            </a> Finding restaurants in Thailand for Indians is quite easy. You can easily get it in the tourist areas.
                                    </p>
                                    <ul>
                                        <li>
                                        Amritsar Restaurant
                                        </li>
                                        <li>
                                        Indian Essence Art Cuisine
                                        </li>
                                        <li>
                                        Masala Art Bangkok
                                        </li>
                                        <li>
                                        Indus Restaurant
                                        </li>
                                        <li>
                                        Charcoal Tandoor Grill & Mixology
                                        </li>
                                        
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">Shopping & Nightlife</Heading>
                                    <p className="lead">
                                    Thai Spa Products, Silk, Gemstones and Handicrafts are popular souvenirs you can take away for your loved ones. Products such as massage oils, soaps, face packs, scrubs, creams, silk scarves, clothes, wood carving, pottery, Keychains, magnets, and T-shirts are a few of the things you must buy from Thailand. Below are some of the Thailand shopping places where you can buy souvenirs-
                                    </p>
                                    <Heading as="h4">List of Shopping malls</Heading>
                                    <ul>
                                        <li>
                                        MBK Center
                                        </li>
                                        <li>
                                        IconSiam
                                        </li>
                                        <li>
                                        Platinum Fashion Mall
                                        </li>
                                        <li>
                                        Asiatique The Riverfront
                                        </li>
                                        <li>
                                        Siam Paragon
                                        </li>
                                        <li>
                                        CentralWorld
                                        </li>
                                        
                                    </ul>
                                    <Heading as="h4">List of Local Market</Heading>
                                    <p className="lead">
                                    Here are some of the 
                                    <a target="_blank" href="https://dimaak.com/blog/shopping-markets-in-bangkok/">
                                                <i>
                                                    <u>
                                                        {" "}
                                                        shopping markets 
                                                    </u>
                                                </i>
                                    </a> to explore
                                    </p>
                                    <ul>
                                        <li>
                                        Chatuchak Weekend Market
                                        </li>
                                        <li>
                                        Pattaya Night market
                                        </li>
                                        <li>
                                        Chiang Mai Night Market
                                        </li>
                                        <li>
                                        Pratumnak Night Market
                                        </li>
                                        <li>
                                        Damnoen Saduak Floating Market
                                        </li>
                                       
                                        
                                    </ul>
                                    <Heading as="h4">Nightlife Fun in Thailand</Heading>
                                    <p className="lead">
                                    Thailand has everything to impress you, from the neon-lit explosion of bars and go-go clubs to live music venues. If clubbing is your dream, you will get world-class DJs. Beach parties with fire shows, buckets of booze, and dancing until sunrise—this is how lively Thailand is. To experience the best nightlife in Thailand, check out some of the <a target="_blank" href="https://dimaak.com/blog/bangkok-nightclubs/">
                                                <i>
                                                    <u>
                                                        {" "}
                                                        best places to enjoy. 
                                                    </u>
                                                </i>
                                    </a> 
                                    </p>
                                    <ul>
                                        <li>
                                        Pattaya's Walking Street
                                        </li>
                                        <li>
                                        Bangkok's RCA (Royal City Avenue)
                                        </li>
                                        <li>
                                        Bangla Road, Phuket's Patong Beach
                                        </li>
                                        <li>
                                        Khao San Road
                                        </li>
                                        <li>
                                        Koh Phangan
                                        </li>
                                       
                                        
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">Dimaak Tours Package for Thailand</Heading>
                                    <p className="lead">
                                    Your dream destination is closer than ever.

                                    </p>
                                    <p className="lead">
                                    Pack your bags, grab your passport, and get ready to create memories of a lifetime in Thailand with our unbeatable prices. Dimaak Tours offers Thailand budget tour packages priced starting at Rs.15,999. You can choose from our diverse range of packages spanning 3N, 4N, 5N, or 6 Nights designed to give you a taste of all the aspects of Thailand. Also, there are different categories to choose from, like solo travel, family trips, group trips or honeymoon trips.

                                    </p>
                                    <p className="lead">
                                    From budget-friendly deluxe rooms to premium hotels, we have everything to suit every traveler's preference. You name it, we book your comfortable stay. Also, you get your complimentary breakfast to start your day.

                                    </p>
                                    <p className="lead">
                                    We take care of not just accommodation but also your airport and sightseeing transfers. Both private and shared transfers are available to suit your needs.

                                    </p>
                                    <p className="lead">
                                    But wait, there's more! We have a customized Thailand tour package for you. We understand that each traveler is unique, which is why we carefully plan and customize the trip while keeping your priorities at the top. Also, our dedicated team is on hand 24/7 to provide assistance for a stress-free experience. So, what are you waiting for? Come on board with us for your Thailand escapade.

                                    </p>
                                    

                                    
                                    
                                </div>
                                <div className="flex flex-col gap-4">
                                    <Heading as="h3">Conclusion</Heading>
                                    <p className="lead">
                                    Thailand is a captivating destination. From the bustling nightlife to the beautiful beaches, it presents a world of culture, adventure, and natural beauty. To taste its beauty, we are focused on creating remarkable experiences that submerge voyagers in the heart and soul of Thailand. Whether you look for the lively energy of metropolitan life, the serenity of islands, or the rich history of temples and shrines, our expertly curated itineraries guarantee that each second is loaded with pleasant surprises and pleasure. So, book your Thailand tour package from Dimaak Tours and enjoy your dream vacation.
                                    </p>
                                    
                                </div>
                                
                            </div>
                        </div>

                        {showSecondContainer && (
                            <div className="traffic-footer flex-wrap flex items-center justify-evenly gap-3 md:gap-5 pt-4">
                                <div>
                                    <a
                                        target="_blank"
                                        href="https://wa.me/919600099777?text=Hi,%20I%20am%20Interested%20in%20Thailand%20Tour%20Packages."
                                    >
                                        <Button
                                            className="flex items-center gap-3"
                                            variant="green"
                                            onClick={handleViewLess}
                                        >
                                            <Image
                                                src={Buttonwhatsapp}
                                                alt="whatsappimage"
                                            />
                                            <span>Get Quote</span>
                                        </Button>
                                    </a>
                                </div>
                                <div
                                    className="flex items-center gap-3 cursor-pointer"
                                    onClick={handleViewLess}
                                >
                                    <span className="text-link">View Less</span>
                                    <Image src={RightIcon} alt="right icon" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Tariff;
